<template>
  <div class="col-12 my-3">
    <div class="row">

      <div class="col-lg-3">

        <div class="bg-white border rounded shadow p-2">
          <h6>انتخاب نوع ایتم</h6>
          <hr>
          <p @click="addQuestion('textarea')" class="form-json-input">متن</p>
          <p @click="addQuestion('radiobox')" class="form-json-input">گزینه ای</p>
          <p @click="addQuestion('selectbox')" class="form-json-input">لیست کشویی</p>
          <p @click="addQuestion('range')" class="form-json-input">دامنه انتخابی</p>
          <p @click="addQuestion('image')" class="form-json-input">عکس</p>
          <p @click="addQuestion('select-box-with-filter')" class="form-json-input">لیست کشویی با فیلتر</p>
          <p @click="addQuestion('text')" class="form-json-input">متن کوتاه</p>

        </div>

        <b-form-checkbox v-model="form.form_questions['answer_without_login']" name="check-button" class="my-3" switch>
          پاسخ بدون ثبت نام
        </b-form-checkbox>

        <div class="form-group mt-4">
          <label v-b-modal.modal-1>
            امتیاز فرم
            <b-icon icon="info-circle-fill"/>
          </label>
          <input type="number" v-model="form.form_questions['total_score']" class="form-control" id="total_score">
        </div>

        <b-modal id="modal-1" hide-footer>
          <div class="text-right" dir="rtl">
            <p>مقدار اگر خالی یا عددی باشد امتیاز محاسبه میشود اما اگر مقدار صفر باشد هیچ امتیازی محاسبه نمیشود.</p>
          </div>
        </b-modal>

      </div>
      <div class="col-lg-9">
        <div class="bg-white border rounded shadow p-2">

          <div class="" v-for="(item,index) in formQuestions" :key="index" v-if="item.visibility != false">


            <textarea-input @removeQuestion="removeQuestion(index)" :item="item" v-if="item.type =='textarea'"/>
            <radio-box-input @removeQuestion="removeQuestion(index)" :item="item" v-if="item.type =='radiobox'"/>
            <select-box-input @removeQuestion="removeQuestion(index)" :item="item" v-if="item.type =='selectbox'"/>
            <range-input @removeQuestion="removeQuestion(index)" :item="item" v-if="item.type =='range'"/>
            <image-input @removeQuestion="removeQuestion(index)" :item="item" v-if="item.type =='image'"/>
            <select-box-with-filter-input @removeQuestion="removeQuestion(index)" :item="item"
                                          v-if="item.type =='select-box-with-filter'"/>
            <text-input @removeQuestion="removeQuestion(index)" :item="item" v-if="item.type =='text'"/>

            <b-icon class="mx-1 h4" icon="arrow-up-circle-fill" @click="moveItem('up',index)"/>
            <b-icon class="mx-1 h4" icon="arrow-down-circle-fill" @click="moveItem('down',index)"/>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextareaInput from "./components/TextareaInput.vue";
import RadioBoxInput from "./components/RadioBoxInput.vue";
import SelectBoxInput from "./components/SelectBoxInput.vue";
import RangeInput from "./components/RangeInput.vue";
import ImageInput from "./components/ImageInput.vue";
import SelectBoxWithFilterInput from "./components/SelectBoxWithFilterInput.vue";
import TextInput from "./components/TextInput.vue";

export default {
  name: "CreateFormJson",
  components: {
    RadioBoxInput,
    TextareaInput,
    SelectBoxInput,
    RangeInput,
    ImageInput,
    SelectBoxWithFilterInput,
    TextInput
  },
  props: {
    form: {}
  },
  computed: {
    formQuestions() {
      if (this.form.form_questions != '') {
        return this.form.form_questions['form']
      }
      this.form.form_questions = {form: [], total_score: null}
      return this.form.form_questions['form']
    }
  },
  methods: {
    removeQuestion(index) {
      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {
        this.formQuestions[index]['visibility'] = false
        this.$forceUpdate()
      }
    },
    moveItem(mode, index) {
      let component = this.formQuestions;

      // Move Up
      if (mode === 'up') {
        if (index > 0) {

          component.splice(index - 1, 1, component.splice(index, 1, component[index - 1])[0]);
        }
      }

      // Move Down
      if (mode === 'down') {
        if (index < component.length - 1) {
          component.splice(index + 1, 1, component.splice(index, 1, component[index + 1])[0]);
        }
      }

      // Force component to re-render after modifying the array
      this.$forceUpdate();
    },
    addQuestion(item) {
      let formQuestionLength = this.formQuestions.length + 1

      let radioBox = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "radiobox",
        "required": true,
        "placeholder": "",
        "options": [
          {
            "id": "1",
            "label": "ایتم 1",
            "value": 1
          },
        ]
      }

      let textarea = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "textarea",
        "required": true,
        "placeholder": ""
      }

      let selectbox = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "selectbox",
        "required": true,
        "placeholder": "",
        "options": [
          {
            "id": "1",
            "label": "ایتم 1",
            "value": 1
          },
        ]
      }

      let range = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "range",
        "required": true,
        "placeholder": "",
        "config": {
          "min": '0',
          "max": '100',
          "step": "1"
        }
      }

      let image = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "image",
        "required": true,
        "placeholder": "",
        "config": {
          "image": ""
        }
      }

      let selectBoxWithFilterInput = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "select-box-with-filter",
        "required": true,
        "placeholder": "",
        "options": [
          {
            "id": "1",
            "label": "ایتم 1",
            "value": 1
          },
        ]
      }

      let text = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "text",
        "required": true,
        "placeholder": "",
        "config": {
          "pattern": ""
        }
      }


      if (item == 'radiobox') {
        let baseObject = Object.assign({}, radioBox)
        this.formQuestions.push(baseObject)
      }
      if (item == 'textarea') {
        let baseObject = Object.assign({}, textarea)
        this.formQuestions.push(baseObject)
      }
      if (item == 'selectbox') {
        let baseObject = Object.assign({}, selectbox)
        this.formQuestions.push(baseObject)
      }
      if (item == 'range') {
        let baseObject = Object.assign({}, range)
        this.formQuestions.push(baseObject)
      }
      if (item == 'image') {
        let baseObject = Object.assign({}, image)
        this.formQuestions.push(baseObject)
      }

      if (item == 'text') {
        let baseObject = Object.assign({}, text)
        this.formQuestions.push(baseObject)
      }

      if (item == 'select-box-with-filter') {
        console.log('w')
        let baseObject = Object.assign({}, selectBoxWithFilterInput)
        this.formQuestions.push(baseObject)
      }
      this.$forceUpdate()
    }
  }
}
</script>


<style scoped>
.form-json-input {
  cursor: pointer;
}
</style>